import SectionChild from "~/components/SectionChild";
import BreadcrumbPageCus from "~/components/breadcrumb-page";
import { useLoaderData } from "react-router";
import { CardRealEstate } from "~/components/card";
import type { Route } from "./+types//mua-ban-mua-ban-can-ho.$slug";
import Heading2 from "../__components/heading2";
import { Copy } from "@repo/ui/components/icon";
import { GeneralErrorBoundary } from "~/components/error-boundary";
import { invariantResponse } from '@epic-web/invariant';
import { serverCallAPI } from '~/services/serverCallAPI';
import { IProduct } from '~/types/address';
import { Icon } from '~/components/ui/icon';
import {PRODUCT_META_ICON, views } from '~/constants/product';
import Carousel, { SelectedSnapDisplay } from '~/components/ui/carousel';
import { CarouselItem } from '@repo/ui/components/carousel';
import { useState } from 'react';
import { Dialog, DialogContent, DialogTitle } from '@repo/ui/components/dialog';
import {
  formatVNPriceTyOrTramTrieu,
  hostName,
  toMeters,
  formatPricePerM2,
} from "~/utils/format";
import { buildProductSeoMeta, buildProductStructured } from '~/utils/seo-product';
import { StructuredDataScript } from '~/components/structured-data-script';
import { getOrigin } from '~/utils/seo';
import { buildCanonical } from '~/utils/seo-common';



export async function loader({ params, request }: Route.LoaderArgs) {
  const slug = params.slug;

  const url = new URL(request.url);
  let data = await serverCallAPI<IProduct>(`/api/product/slug/${slug}`).catch(
    (error) => {
      console.log(error);
      return null;
    }
  );

  invariantResponse(data, "Không tìm thâý sản phẩm", { status: 404 });
  const related = data?.suggestionProducts || [];


  const normalized: IProduct = data

  const origin = getOrigin(request);

  const thumbnails =
    normalized.thumbnails?.map((thumb) => thumb.fileUrl).filter(Boolean) || [];
  const imagesFromFiles =
    normalized.images?.map((img) => img.fileUrl).filter(Boolean) || [];
  const imagesFromImageUrls = (normalized as any).imageUrls || [];

  const primaryImage =
    thumbnails[0] ||
    imagesFromFiles[0] ||
    imagesFromImageUrls[0] ||
    "/image/landing_page/image-2.png";

  const images = thumbnails.length
    ? thumbnails
    : imagesFromFiles.length
    ? imagesFromFiles
    : imagesFromImageUrls;
  const description =
    normalized.description ||
    `Thông tin chi tiết về bất động sản ${normalized.name}`;
  const productUrl = origin
    ? `${origin}/mua-ban-mua-ban-can-ho/${normalized.slug}`
    : `/mua-ban-mua-ban-can-ho/${normalized.slug}`;
  const canonicalUrl = origin
    ? `${origin}${url.pathname}${url.search}`
    : `${url.pathname}${url.search}`;


  return {
    product: normalized,
    related,
    seo: {
      canonical: canonicalUrl,
      title: normalized.name,
      description,
      image: primaryImage,
      url: productUrl,
      // price: data.keys?.price,
      currency: "VND",
      category: normalized.categoryName,
      images,
    },
    productStructuredData: buildProductStructured({
      name: normalized.name,
      description,
      images: images.length ? images : [primaryImage],
      url: productUrl,
      sku: normalized.code,
      category: normalized.categoryName,
      price: normalized?.keys?.price,
      currency: "VND",
      availability: "InStock",
    }),
  };
};



function ModalListGallery({
  mediaItems,
}: {
  mediaItems: { src: string; mimeType: string }[];
}) {
  const slides = mediaItems.map((item, index) => {
    const isVideo = item.mimeType?.startsWith("video");
    if (isVideo) {
      return (
        <video
          key={index}
          src={item.src}
          controls
          className="absolute w-full h-full bg-contain"
        />
      );
    }
    return (
      <img
        src={item.src}
        width={54}
        height={40}
        className="absolute w-full h-full bg-contain"
        alt={"Image"}
        key={index}
        loading="lazy"
      />
    );
  });
  return (
    <DialogContent
      className="flex-col w-screen h-screen max-w-full p-0 m-0"
    >
      <DialogTitle className="flex p-4 ">
        Ảnh sản phẩm
      </DialogTitle>
      <div className="flex flex-col flex-1">
        <Carousel
          className="relative "
          userOptions={{ playOnInit: false }}
          opts={{
            loop: true,
          }}
          slides={slides}
          slotSnapDisplay={
            <SelectedSnapDisplay className="block absolute bottom-4 right-4 bg-black/30 backdrop-blur md:hidden z-[2] py-[2px] px-1 text-sm text-white rounded-sm" />
          }
        >
          {mediaItems.map((item, idx) => {
            const isVideo = item.mimeType?.startsWith("video");
            return (
              <CarouselItem
                className="relative w-full h-full p-0 overflow-hidden bg-black lg:min-h-[500px]"
                key={idx}
              >
                {isVideo ? (
                  <video
                    src={item.src}
                    controls
                    className="object-contain w-full h-full max-h-[70vh] m-auto inset-2/4"
                  />
                ) : (
                  <img
                    src={item.src}
                    className="object-contain w-full h-full max-h-[70vh] m-auto  inset-2/4"
                    alt="Kland"
                  />
                )}
              </CarouselItem>
            );
          })}
        </Carousel>
      </div>
    </DialogContent>
  );
}

function ListGallery({ product }: { product: IProduct }) {
  const [open, setOpen] = useState(false);

  const imagesFromFiles =
    product.images?.map((img) => ({
      src: img.fileUrl,
      mimeType: img.mimeType || "image/jpeg",
    })) ?? [];

  const imagesFromImageUrls =
    (product as any).imageUrls?.map((url: string) => ({
      src: url,
      mimeType: "image/jpeg",
    })) ?? [];

  const displayMedia = [...imagesFromFiles, ...imagesFromImageUrls].filter(
    (item) => !!item.src
  );
  const mediaToRender = displayMedia.length
    ? displayMedia
    : [{ src: "/image/landing_page/feature-image/bg-1.jpg", mimeType: "image/jpeg" }];
  const handleCloseModal = (value: boolean) => {
    setOpen(value);
  };
  return (
    <>
      <div className="md:hidden">
        <Carousel
          className="relative w-full"
          userOptions={{ playOnInit: false }}
          opts={{
            loop: true,
          }}
          slotSnapDisplay={
            <SelectedSnapDisplay className="block absolute bottom-4 right-4 bg-black/30 backdrop-blur md:hidden z-[2] py-[2px] px-1 text-sm text-white rounded-sm" />
          }
        >
          {mediaToRender.map((item, idx) => {
            const isVideo = item.mimeType?.startsWith("video");
            return (
              <CarouselItem
                className="p-0 w-full relative overflow-hidden aspect-[4/3] hover:cursor-pointer"
                key={idx}
                onClick={() => setOpen(true)}
              >
                {isVideo ? (
                  <video
                    src={item.src}
                    controls
                    playsInline
                    className="absolute object-cover w-full h-full"
                  />
                ) : (
                  <img
                    src={item.src}
                    width={375}
                    height={240}
                    className="absolute object-contain w-full h-full"
                    alt="Kland"
                    loading="lazy"
                  />
                )}
              </CarouselItem>
            );
          })}
        </Carousel>
      </div>
      <SectionChild className="md:py-6">
        <BreadcrumbPageCus title={product.name} />
        <div className="hidden md:grid md:grid-cols-[1fr_320px] gap-4 max-h-[960px] relative">
          <div
            className="relative  overflow-hidden rounded-2xl hover:cursor-pointer max-h-[500px] h-[500px]"
            onClick={() => setOpen(true)}
          >
            {mediaToRender[0].mimeType?.startsWith("video") ? (
              <video
                src={mediaToRender[0].src}
                controls
                className="absolute object-contain w-full h-full hover:scale-100"
              />
            ) : (
              <img
                src={mediaToRender[0].src}
                alt={product.name}
                className="absolute object-contain w-full h-full hover:scale-100"
              />
            )}
          </div>
          <div className="grid grid-rows-2 gap-4">
            {mediaToRender.slice(1, 3).map((item, i) => (
              <div
                key={i}
                className="rounded-2xl overflow-hidden h-[120px] md:h-auto hover:cursor-pointer max-h-[245px]"
                onClick={() => setOpen(true)}
              >
                {item.mimeType?.startsWith("video") ? (
                  <video
                    src={item.src}
                    controls
                    className="object-cover w-full h-full hover:scale-100 "
                  />
                ) : (
                  <img
                    src={item.src}
                    alt={`${product.name}-${i}`}
                    className="object-cover w-full h-full hover:scale-100 "
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </SectionChild>
      <Dialog open={open} onOpenChange={handleCloseModal}>
        <ModalListGallery mediaItems={mediaToRender} />
      </Dialog>
    </>
  );

}

export default function ProductDetail() {
  const { product, related, productStructuredData } = useLoaderData<typeof loader>();

  async function copyToClipboard(text: string) {
    try {
      await navigator.clipboard.writeText(text);

    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  }
  const detail = [
    {
      key: "determineBlocks",
      value: product?.block,
      suffix: "",
      icon: PRODUCT_META_ICON.determineBlocks,
      label: "Block/Tòa",
    },
    {
      key: "floor-number",
      value: product?.floorNumber,
      suffix: " tầng",
      icon: PRODUCT_META_ICON.floorNumber,
      label: "Tầng",
    },
    {
      key: "building-2",
      value: product?.floorNumber,
      icon: PRODUCT_META_ICON["building-2"],
      label: "Mã căn hộ",
    },
    {
      key: "residentialArea",
      value: product?.residentialArea,
      icon: PRODUCT_META_ICON.area,
      label: "Diện tích thổ cư",
      suffix: " m²",
    },
    {
      key: "plotsNumber",
      value: product?.plotsNumber,
      icon: PRODUCT_META_ICON["grid-2x2"],
      label: "Số thửa",
    },
  ].filter((m) => m.value !== undefined && m.value !== null && m.value !== "");

  return (
    <div>
      <StructuredDataScript data={productStructuredData} />
      <ListGallery product={product} />
      <SectionChild>
        {/* Title + meta */}
        <div className="mt-8">
          <Heading2>{product.name}</Heading2>
          {/* <p>Địa chỉ: {product.address}</p> */}
          <div className="flex mt-2 gap-x-2">
            <p>
              Mã bất động sản:<span className="font-bold"> {product.code}</span>
            </p>

            <Copy
              className="hover:cursor-pointer text-primary"
              onClick={() => copyToClipboard(product.code)}
            />
          </div>
          <div className="flex items-baseline gap-3 mt-3">
            <div className="text-3xl font-bold text-primary">
              {product?.price &&
                formatVNPriceTyOrTramTrieu(Number(product.price))}{" "}
            </div>
            {product?.price && product?.area && (
              <div className="text-sm">
                {formatPricePerM2(
                  Math.round(Number(product?.price) / Number(product?.area)),
                )}
              </div>
            )}
          </div>

          <div className="grid grid-cols-2 gap-3 mt-4 md:grid-cols-3">
            {detail.map((d) => (
              <div
                className="flex flex-col gap-1 title-tabs title-small"
                key={String(d.key)}
              >
                <div className="flex items-center gap-2">
                  <Icon name={d.icon} className="text-2xl" />
                  {d.label}
                </div>
                <span className="font-bold">
                  {d.value}
                  {d.suffix}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Details */}
        <div className="mt-10 space-y-6">
          <h2 className="text-xl font-semibold">Chi tiết căn</h2>
          <div className="grid gap-4 text-sm md:grid-cols-4">
            {[
              {
                key: "determine",
                value: product?.determine,
                suffix: "",
                icon: PRODUCT_META_ICON.determine,
                label: "Hướng ban công",
              },
              {
                key: "view",
                value:
                  product?.keys?.properties?.view &&
                  views.find((v) => v.key === product?.keys?.properties?.view)
                    ?.label,
                suffix: "",
                icon: PRODUCT_META_ICON.view,
                label: "Tầm nhìn",
              },
              {
                key: "view",
                value:
                  product?.keys?.properties?.view &&
                  views.find((v) => v.key === product?.keys?.properties?.view)
                    ?.label,
                suffix: "",
                icon: PRODUCT_META_ICON.view,
                label: "Tầm nhìn",
              },
              {
                key: "alleyWidth",
                value:
                  product?.alleyWidth && ` ${toMeters(product?.alleyWidth)} m`,
                suffix: "",
                icon: PRODUCT_META_ICON.area,
                label: "Độ rộng ngõ (đường) Trước mặt",
              },
              {
                key: "bedroomsNumber",
                value: product?.bedroomsNumber,
                suffix: "",
                icon: PRODUCT_META_ICON.bedrooms,
                label: "Số phòng ngủ",
              },
              {
                key: "wc",
                value: product?.toiletsNumber,
                suffix: "",
                icon: PRODUCT_META_ICON.wc,
                label: "Số WC",
              },
              {
                key: "wc",
                value: product?.width,
                suffix: " m",
                icon: PRODUCT_META_ICON.area,
                label: "Chiều rộng",
              },
              {
                key: "length",
                value: product?.length,
                suffix: " m",
                icon: PRODUCT_META_ICON.area,
                label: "Chiều dài",
              },
              {
                key: "area",
                value: product?.area,
                suffix: " m²",
                icon: PRODUCT_META_ICON.area,
                label: "Diện tích",
              },
              {
                key: "ownerShipType",
                value: product?.ownerShipType,
                icon: PRODUCT_META_ICON["gallery-horizontal-end"],
                label: "Loại sổ",
              },
            ]
              .filter((m) => m.value !== undefined && m.value !== null)
              .map((m) => (
                <div
                  className="flex flex-col gap-1 title-tabs title-small"
                  key={String(m.key)}
                >
                  <div className="flex items-center gap-2">
                    <Icon name={m.icon} className="w-6 h-6 " />
                    {m.label}
                  </div>
                  <span>
                    {m.value} {m.suffix}
                  </span>
                </div>
              ))}
          </div>
        </div>

        <div className="mt-10 space-y-4">
          <h2 className="text-xl font-semibold">Quy mô</h2>
          <div>{product.address}</div>
        </div>
        <div className="mt-10 space-y-4">
          <h2 className="text-xl font-semibold">Liên hệ: Kland Tuyên Quang</h2>
          <div>
            <a href="tel:0975634828">SĐT: 0975 634 828</a>
          </div>
        </div>
        {/* Related */}
        <div className="mt-12 pb-[100px]">
          <Heading2 className="lg:text-3xl">Căn tương tự cùng dự án</Heading2>
          <div className="grid gap-6 mt-6 md:grid-cols-2 lg:grid-cols-3">
            {related.map((p) => (
              <CardRealEstate key={p.id} product={p as any} />
            ))}
          </div>
        </div>
      </SectionChild>
    </div>
  );
}

export const meta = (args: Route.MetaArgs) => {
  const seo = args.data?.seo;
  if (!seo) return [];
  return buildProductSeoMeta({
    title: seo.title,
    description: seo.description,
    image: seo.image,
    url: seo.url || hostName(args.location?.pathname || ""),
    type: "product",
    siteName: "Kland",
    keywords: seo.category,
  });
};


export function ErrorBoundary() {
  return (
    <GeneralErrorBoundary
      statusHandlers={{
        404: () => <p>Không tìm thấy sản phẩm</p>,
      }}
    />
  );
}
export const handle = {
  dynamicLinks: (props: any) => {
    const canonical = props?.data?.seo?.canonical || "";
    if (!canonical) return null;
    const url = new URL(canonical);
    const links = buildCanonical(url.origin, url.pathname + url.search);
    // react-router expects a single link definition or array
    return Array.isArray(links) ? links : [links];
  },
};
